/**
 * Google drive api plugin.
 */

/*eslint-disable */
import MultipartBuilder from './multipart';

class GoogleDrivePlugin {

  constructor(options) {
    this.observers = {};

    const CLIENT_ID = options.client_id;
    const auto_login = options.auto_login || false;
    // Array of API discovery doc URLs for APIs used by the quickstart
    const DISCOVERY_DOCS = ['https://www.googleapis.com/discovery/v1/apis/drive/v3/rest'];
    // Authorization scopes required by the API; multiple scopes can be
    // included, separated by spaces.
    const SCOPES = 'https://www.googleapis.com/auth/drive';

    gapi.load('client:auth2', () => {
      gapi.client.init({
        discoveryDocs: DISCOVERY_DOCS,
        clientId: CLIENT_ID,
        scope: SCOPES
      }).then(() => {
        let isSignedIn = this.isSignIn;
        this.notify('gapi.auth2:loaded', isSignedIn);
        // Listen for sign-in state changes.
        if (!isSignedIn) {
          gapi.auth2.getAuthInstance().isSignedIn.listen(() => {
            this.notify('isSignInChanged', this.isSignIn);
          });
          if (this.auto_login) {
            this.signIn();
          }
        }
      });
    });

    gapi.load('picker', {'callback': () => {
      this.notify('picker:loaded');
    }});
  }

  get isSignIn() {
    return gapi.auth2.getAuthInstance().isSignedIn.get();
  }

  get user() {
    return gapi.auth2.getAuthInstance().currentUser.get();
  }

  signIn() {
    try {
      return gapi.auth2.getAuthInstance().signIn();
    }
    catch (e) { console.error(e); }
  }

  signOut() {
    try {
      return gapi.auth2.getAuthInstance().signOut();
    }
    catch (e) { console.error(e); }
  }

  file(id, fields='*', ...args) {
    return gapi.client.drive.files.get({
      fileId: id,
      fields: fields,
      ...args,
    });
  }

  fileContent(id) {
    return gapi.client.drive.files.get({
      fileId: id,
      alt: 'media',
    });
  }

  files(q = 'name contains \'.md\'', fields = "files(id, name, parents)", ...args) {
    return gapi.client.drive.files.list({
      q: q,
      fields: fields,
      ...args,
    })
  }

  saveFile(file, content) {
    let path;
    let method;

    if (file.id) {
      path = '/upload/drive/v3/files/' + encodeURIComponent(file.id);
      method = 'PATCH';
    }
    else {
      path = '/upload/drive/v3/files';
      method = 'POST';
    }

    const metadata = {
      mimeType: file.mimeType || 'text/markdown',
      name: file.name
    };

    let multipart = new MultipartBuilder()
        .append('application/json', JSON.stringify(metadata))
        .append(metadata.mimeType, content)
        .finish();
    return gapi.client.request({
      path: path,
      method: method,
      params: {
        uploadType: 'multipart',
        fields: '*',
      },
      headers: { 'Content-Type': multipart.type },
      body: multipart.body,
    });
  }

  delete(fileId) {
    return gapi.client.request({
      path: '/drive/v3/files/' + fileId,
      method: 'DELETE',
    });
  }

  on(event, func) {
    if (this.observers[event] === undefined) {
      this.observers[event] = [];
    }
    this.observers[event].push(func);
  }

  notify(event, ...params) {
    if (this.observers[event] !== undefined) {
      for (let i in this.observers[event]) {
        this.observers[event][i](...params);
      }
    }
  }
}

export default {
  /**
   * Install plugin.
   * @param Vue
   * @param options
   *   Options is an object like:
   *     - client_id
   */
  install(Vue, options) {
    const googleDrive = new GoogleDrivePlugin(options);
    Vue.googleDrive = googleDrive;
  },
};
/*eslint-enable */



// WEBPACK FOOTER //
// ./src/plugins/google_drive/google_drive.js